module.exports = __webpack_public_path__ + "img/title.48dc7f1.png";